import { render, staticRenderFns } from "./resultunit-calculation.vue?vue&type=template&id=1a499251&scoped=true"
import script from "./resultunit-calculation.vue?vue&type=script&lang=js"
export * from "./resultunit-calculation.vue?vue&type=script&lang=js"
import style0 from "./resultunit-calculation.vue?vue&type=style&index=0&id=1a499251&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a499251",
  null
  
)

export default component.exports